<div
  class="spinner"
  [ngClass]="spinnerClasses"
  [style.min-width]="computedSize.width + 'px'"
  [style.min-height]="computedSize.width + 'px'"
  [style.max-width]="computedSize.width + 'px'"
  [style.max-height]="computedSize.width + 'px'"
  [style.border-width]="computedSize.stroke + 'px'"></div>
